import React from 'react';
import { useFubConnectionContextRequired } from './FubConnectionContext';
import { FubIntegrationToggleWrapper } from 'feature-toggle';
import { SimpleBlock } from 'ui-builder';

import styles from './FubConnectionProfileIcon.module.scss';
import { ConnectionStatus, TeamPermission } from 'nekst-api';
import { AccessChecker } from 'authorization-scope';

export function FubConnectionProfileIcon() {
  const context = useFubConnectionContextRequired();

  return (
    <FubIntegrationToggleWrapper>
      <AccessChecker permissionToCheck={TeamPermission.READ_FUB_CONNECTION}>
        {context.profiles.length > 0 && context.profiles[0].status === ConnectionStatus.ACTIVE && (
          <SimpleBlock className={styles.block} title={context.profiles[0].connectionLabel}>
            {context.profiles ? 'FUB Connected' : null}
          </SimpleBlock>
        )}
      </AccessChecker>
    </FubIntegrationToggleWrapper>
  )
}
